import React, { Component, PropTypes } from 'react'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'
import { getGMAPAddressComponents, formatAddress } from 'common/helpers'
import FontAwesome from 'react-fontawesome'

class ClientAddress extends Component {
    constructor(props) {
        super()
        this.state = {
            lastUpdated: null,
            address: formatAddress(props.client),
            client: props.client._id,
            center: {
                lat: null,
                lng: null
            }
        }
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.props.client._id !== nextProps.client._id)
            this.setState({ address: formatAddress(nextProps.client) })
    }
    

    onChange(address) {
        this.setState({ address })
        /*geocodeByAddress(address, (err, center, results) => {
            if (err) return
            const now = new Date().getTime()
            this.setState({ center, lastUpdated: now })
            const location = results && results[0] ? getGMAPAddressComponents(results[0].address_components) : {}
            location.lat = center.lat
            location.lng = center.lng
            if (location.street) {
                setTimeout(() => {
                    if (this.state.lastUpdated === now)
                        this.props.onSubmit(location)
                }, 1000)
            }
        })*/
    }

    onSelect(address) {
        geocodeByAddress(address, (err, center, results) => {
            if (err) return
            this.setState({ center })
            const location = results && results[0] ? getGMAPAddressComponents(results[0].address_components) : {}
            location.lat = center.lat
            location.lng = center.lng
            if (location.street)
                this.props.onSubmit(location)
        })
    }

    render() {
        const { client } = this.props
        const classNames = {
            input: 'content-editable',
            root: 'inline-block input'
        }
        if (!client) return (<div></div>)
        return (
            <div>
                <div className='relative h5'>
                    <FontAwesome name='map-marker' style={{ marginRight: 15 }}/>
                    <PlacesAutocomplete onChange={ this.onChange.bind(this) } onSelect={ this.onSelect.bind(this) } value={ this.state.address } classNames={ classNames }/>
                </div>
            </div>
        )
    }
}

export default ClientAddress


// WEBPACK FOOTER //
// ./src/client/features/client/components/ClientAddress.jsx